import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { ERiskWaningStatus, IRiskWarningDetail, IRiskWarningItem, IRiskWarningParams } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 风控管理 - 风控预警分页
 */
export async function queryEarlyWarningPage(params: IRiskWarningParams) {
  let data = [] as IRiskWarningItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{ data: IRiskWarningItem[]; total: number }>(`${hostUrl}/risk/alert/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: resData, total: resTotal } = context || {};

      data = resData || [];
      total = resTotal || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 风控管理 - 风控预警 - 导出
 */

export async function exportEarlyWarning(params: IRiskWarningParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(`${hostUrl}/risk/alert/export`, params, { responseType: 'blob' });

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 风控管理 - 风控预警详情
 */
export async function queryEarlyWarningDetail(alertId: string) {
  let data = {} as IRiskWarningDetail;

  try {
    const { code, context, message } = await Http.get<IRiskWarningDetail>(`${hostUrl}/risk/alert/${alertId}/detail`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 风控管理 - 处理预警
 */
export async function handleEarlyWarning(alertNoList: string[], alertStatus: ERiskWaningStatus, remark: string) {
  let data = {} as IRiskWarningDetail;

  try {
    const { code, context, message } = await Http.post<IRiskWarningDetail>(`${hostUrl}/risk/alert/handle`, {
      alertNoList,
      alertStatus,
      remark,
    });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}